import { IFeatureToggleResponse } from './FeatureToggleResponse'
import { commonApiClient } from '../../../util/apiClient/commonApiClient'

export declare interface IFeatureToggleApi {
  getFeatureToggle(): Promise<string>
}

export const featureToggleApi: IFeatureToggleApi = {
  async getFeatureToggle(): Promise<string> {
    const response = await commonApiClient.post<IFeatureToggleResponse>('/frontEndToggle')
    return response.data.toggles
  },
}

export const mockFeatureToggleApi: IFeatureToggleApi = {
  async getFeatureToggle(): Promise<string> {
    return JSON.stringify({
      disableCurrencyDisplay: 'true',
      disableLeaveGameBtn: 'true',
      disableLeaveGameBtnByRedirectUrlNotExisted: 'false',
      disableRTPDisplay: 'true',
      disableFunkyGameLogo: 'false',
      disableHistoryList: 'false',
      disableChangePose: 'false',
      disableTutorial: 'false',
      disableBuyBonus: 'false',
    })
  },
}
